<template>
    <div v-if="notificationObj.type === 'invite'" class="cursor-pointer border-b border-gray-200 dark:border-black-600 last:border-none">
        <div
            class="noticeBox flex items-start p-4 gap-2 cursor-pointer border-b border-gray-200 dark:border-black-600 last:border-none"
            :class="{ 'bg-gray-100 dark:bg-black-900': !notificationObj.isRead }"
            @click="itemClick(notificationObj)"
        >
            <img
                src="https://www.gnomen.co.uk/media/gnomen.co.uk/img/team/uk/team-hassan.png"
                alt="User Avatar"
                class="userImg w-8 h-8 rounded-full"
            />
            <div class="noticeCenter flex flex-col sm:w-[24.625rem]">
                    <span class="font-medium text-black-600 mr-1 text-sm dark:text-white">
                        <span v-if="notificationObj.invitedUser" class="font-extrabold">
                            {{ notificationObj.invitedUser }}
                        </span>
                        {{ notificationObj.title }}
                    </span>
                <span class="block text-xs text-gray-500 mt-1 dark:text-gray-400">{{ notificationObj.duration }}</span>
            </div>
            <div v-if="!notificationObj.isRead" class="ml-auto">
                <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="3" cy="3" r="3" fill="#00B0FC" />
                </svg>
            </div>
        </div>
    </div>

    <div v-if="['diary', 'permission'].includes(notificationObj.type)" class="cursor-pointer border-b border-gray-200 dark:border-black-600 last:border-none">
        <div
            class="noticeBox flex items-start p-4 gap-2 cursor-pointer border-b border-gray-200 dark:border-black-600 last:border-none"
            :class="{ 'bg-gray-100 dark:bg-black-900': !notificationObj.isRead }"
            @click="itemClick(notificationObj)"
        >
            <img
                v-if="notificationObj.type === 'permission'"
                src="https://www.gnomen.co.uk/media/gnomen.co.uk/img/team/uk/team-hassan.png"
                alt="User Avatar"
                class="userImg w-8 h-8 rounded-full"
            />
            <MutliContactNameIcon v-else :data="notificationObj.contacts" :isFull="false" :isShow="false" :isLarge="true" />
            
            <div class="noticeCenter flex flex-col sm:w-[24.625rem]">
                    <span class="font-medium text-black-600 mr-1 text-sm dark:text-white">
                        <span v-if="notificationObj.invitedUser" class="font-extrabold">
                            {{ notificationObj.invitedUser }}
                        </span>
                        {{ notificationObj.title }}
                    </span>
                <span class="text-xs text-gray-500 mt-1 flex items-center gap-1 mb-3 dark:text-gray-400">
                    {{ notificationObj.duration }}
                    <fa v-if="notificationObj.property" :icon="['fas', 'circle']" class="text-gray-200 text-[0.3125rem]" />
                    {{ notificationObj.property }}
                </span>
                <p v-if="notificationObj.confirmed" class="flex items-center gap-1">
                    <fa :icon="['fal', 'check']" class="text-green-500 text-sm" />
                    <span class="text-sm font-semibold text-black-600 dark:text-white">Accepted</span>
                </p>                   
                <div class="btnActns flex gap-2" v-if="!notificationObj.confirmed">
                    <AppButton btn-text="Accept" variant="blue" @click.stop="handleAccept" />
                    <AppButton btn-text="Decline" variant="blue" outline @click.stop="handleDecline" />
                </div>
            </div>
            <div v-if="!notificationObj.isRead">
                <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="3" cy="3" r="3" fill="#00B0FC" />
                </svg>
            </div>
        </div>
    </div>

    <div v-if="['offers', 'document'].includes(notificationObj.type)" class="cursor-pointer border-b border-gray-200 dark:border-black-600 last:border-none">
        <div
            class="noticeBox flex items-start p-4 gap-2 cursor-pointer border-b border-gray-200 dark:border-black-600 last:border-none"
            :class="{ 'bg-gray-100 dark:bg-black-900': !notificationObj.isRead }"
            @click="itemClick(notificationObj)"
        >
            <MutliContactNameIcon :data="notificationObj.contacts" :isFull="false" :isShow="false" :isLarge="true" />
            
            <div class="noticeCenter flex flex-col sm:w-[24.625rem]">
                
                    <span class="font-medium text-black-600 mr-1 text-sm dark:text-white">
                        <span v-if="notificationObj.invitedUser" class="font-extrabold">
                            {{ notificationObj.invitedUser }}
                        </span>
                        {{ notificationObj.title }}
                    </span>
                <span class="text-xs text-gray-500 mt-1 flex items-center gap-1 dark:text-gray-400">
                    {{ notificationObj.duration }}
                    <fa v-if="notificationObj.property" :icon="['fas', 'circle']" class="text-gray-200 text-[0.3125rem]" />
                    {{ notificationObj.property }}
                </span>
            </div>
            <div v-if="!notificationObj.isRead">
                <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="3" cy="3" r="3" fill="#00B0FC" />
                </svg>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from "vue";
import AppButton from "@/components/appComponents/AppButton.vue";
import MutliContactNameIcon from "@/components/contacts/MutliContactNameIcon.vue";

const props = defineProps({
    notificationObj: {
        type: Object,
        default: () => ({}),
    },
});

const itemClick = (item) => {
    console.log("itemClick", item);
};

const handleAccept = () => {
    console.log("handleAccept");
};

const handleDecline = () => {
    console.log("handleDecline");
};
</script>

<style scoped>
.noticeBox {
    @apply hover:bg-gray-100 dark:hover:bg-black-900;
    transition: background-color 0.3s;
}

</style>
